import { createAccentVariations } from '../../../shared/utils/strings';

export const useGetAccentedQueryArray = (query: string) => {
  const splitQuery = query.split(' ');

  const highlightPatterns = splitQuery.map(word =>
    createAccentVariations(word),
  );
  const flattenedHighlightPatterns = highlightPatterns.flat();
  return flattenedHighlightPatterns;
};
